export const DEFAULT_TEXT_UNRAISED_ESCALATION = "History would appear here once escalation has been raised.";
export const DEFAULT_TEXT_RAISED_ESCALATION = "No activity available for this escalation.";